module.exports = __webpack_public_path__ + "static/monuma-bebab22ba4bd94685f69e5fffa9b9c48.mp4";